var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 3.75H4.875C4.42627 3.75 4.0625 4.08579 4.0625 4.5V19.5C4.0625 19.9142 4.42627 20.25 4.875 20.25H21.125C21.5737 20.25 21.9375 19.9142 21.9375 19.5V4.5C21.9375 4.08579 21.5737 3.75 21.125 3.75Z",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55713 11.0718L13.0001 14.2499L16.4431 11.0718",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.75V14.25",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 15H7.78984C7.89535 14.9997 7.99989 15.0185 8.09748 15.0555C8.19508 15.0925 8.28381 15.1469 8.35859 15.2156L10.3289 17.0344C10.4037 17.1031 10.4924 17.1575 10.59 17.1945C10.6876 17.2315 10.7922 17.2503 10.8977 17.25H15.1023C15.2078 17.2503 15.3124 17.2315 15.41 17.1945C15.5076 17.1575 15.5963 17.1031 15.6711 17.0344L17.6414 15.2156C17.7162 15.1469 17.8049 15.0925 17.9025 15.0555C18.0001 15.0185 18.1047 14.9997 18.2102 15H21.9375",
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f86576a222ff6950e70fb97e6166220a.svg";
export { ForwardRef as ReactComponent };